/** Accordion JS */
var acc = document.getElementsByClassName("gw-accordion");
var hotspots = document.getElementsByClassName("gw-hotspot");
var i;

function toggleHotspot(element) {
    document.querySelectorAll(".gw-hotspot.active").forEach(function(hotspot) {
      hotspot.classList.remove("active");
    });
    document.querySelectorAll(".gw-accordion.active").forEach(function(accordion) {
      accordion.classList.remove("active");
      accordion.setAttribute('aria-selected', 'false');
    });
    let hotspotID = element.dataset.hotspotid;
    let hotspotEl = document.querySelector(".gw-hotspot[data-hotspotid='" + hotspotID + "']");
    let accordionEl = document.querySelector(".gw-accordion[data-hotspotid='" + hotspotID + "']");
    if(hotspotEl){
      hotspotEl.classList.toggle("active");
    }
    if(accordionEl){
      accordionEl.classList.toggle("active");
      accordionEl.setAttribute('aria-selected', accordionEl.classList.contains('active') ? 'true' : 'false');
    }
}

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    toggleHotspot(this)
  });
}

for (i = 0; i < hotspots.length; i++) {
  hotspots[i].addEventListener("click", function() {
    toggleHotspot(this)
  });
}

document.querySelectorAll('.thumbnail-list--desktop--container').forEach(function(container) {
  const swiper = new Swiper(container, {
    direction: 'vertical',
    slidesPerView: 'auto',
    autoHeight: false,
    spaceBetween: 10,
    loop: false,
    mousewheel: true,
    allowTouchMove: true,
    enabled:true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    freeMode: true,
    centeredSlides: false,
    centeredSlidesBounds: false, 
  });
  swiper.on('touchMove', function () {
    console.log("swiper moved");
  });
});

document.querySelectorAll('a[role="button"]').forEach(link => {
  link.addEventListener('keydown', (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault(); // Prevents page scrolling when pressing Space
      link.click(); // Triggers the click event
    }
  });
});